import { ready } from './lib/dom';

function resized() {
  const { parent } = window;

  if (!parent) {
    return;
  }

  parent.postMessage({
    action: 'g8/resize',
    height: document.body.scrollHeight,
  }, '*');
}

ready(() => {
  resized();
  let height = document.body.scrollHeight;

  // throttled resize listener
  let timeout;
  window.addEventListener('resize', () => {
    clearTimeout(timeout);
    timeout = setTimeout(resized, 250);
  });

  setInterval(() => {
    if (height !== document.body.scrollHeight) {
      height = document.body.scrollHeight;
      resized();
    }
  }, 1000 * 2);

  const isIframe = window.self !== window.top;
  const $body = document.querySelector('body');

  if (isIframe && $body) {
    $body.classList.add('is-iframe');
  }
});
